<template>
  <div class="container">
    <h1>Hi there</h1>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style lang="scss">

</style>